import {profCollaborator} from 'constants/url';
import useAdd from '../../../components/hooks/useAdd';
import {AddingOptions} from '../../../components/grid-dx/types';

function useAddProfCollaborator() {
  const addProfCollaborator = useAdd(profCollaborator);
  return (addingOptions: AddingOptions) => addProfCollaborator(addingOptions);
}

export default useAddProfCollaborator;
